import './styles.scss';
import { Flex, Table, Tbody, Td, Tr, Box, Button, useDisclosure } from '@chakra-ui/react';
import { ChevronUpIcon } from '@chakra-ui/icons';
import { ConditionalComponent, IterationComponent } from '@components/functionComponent';
import { useEffect, useState } from 'react';
import PaginationComp from './PaginationComp';
import TableHeadComp from './TableHeadComp';
import AddItemComp from './AddItemComp';
import NoData from './NoData';
import { isEmpty, matchesProperty, omit, reject, size } from 'lodash';
import SkeletonComponent from '@components/skeleton';

export default function TableAddItem({
    limit = 10,
    fontSize = '14px',
    sortType = 'asc',
    tableList = {},
    page = 1,
    pageCount = 1,
    onPageChange = () => {},
    totalData = 0,
    onSort = () => {},
    onChangeLimit = () => {},
    data = [],
    isLoading = false,
    isLoadingQueryItem = false,
    isAddItem = true,
    queryAddItem = [],
    onSelectItem = () => {},
    onSearchItem = () => {},
    groupBy = null,
    editingRow = null,
    fetchNextPage = () => {},
    hasNextPage = false,
    isFetchingNextPage = false,
    addBtnLabel,
    placeholder,
    isHideAction = true,
    noDataDescription = 'Saat ini, data Produk belum diinput',
}) {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const filteredHeaders = !isAddItem && isHideAction ? tableList?.filter((h) => h.key !== 'action') : tableList;

    const [expandedRow, setExpandedRow] = useState(null);
    const handleToggleExpand = (rowIndex) => {
        setExpandedRow((prev) => (prev === rowIndex ? null : rowIndex));
    };

    useEffect(() => {
        if (!isEmpty(editingRow)) onOpen();
    }, [editingRow]);

    return (
        <Box>
            <Table w={'full'}>
                <TableHeadComp tableList={filteredHeaders} fontSize={fontSize} onSort={onSort} sortType={sortType} />

                <ConditionalComponent statement={isAddItem}>
                    <AddItemComp
                        tableList={filteredHeaders}
                        isAddItem={isAddItem}
                        onOpen={onOpen}
                        isOpen={isOpen}
                        onClose={onClose}
                        queryAddItem={queryAddItem}
                        isLoading={isLoadingQueryItem}
                        onSelectItem={onSelectItem}
                        onSearchItem={onSearchItem}
                        groupBy={groupBy}
                        editingRow={editingRow}
                        fetchNextPage={fetchNextPage}
                        hasNextPage={hasNextPage}
                        isFetchingNextPage={isFetchingNextPage}
                        addBtnLabel={addBtnLabel}
                        placeholder={placeholder}
                    />
                </ConditionalComponent>

                <ConditionalComponent statement={data?.length > 0 && !isLoading}>
                    <Tbody>
                        <IterationComponent
                            arr={data}
                            render={(value, valueIndex) => {
                                const isExpand = value.is_basepack;
                                return (
                                    <>
                                        <Tr
                                            key={valueIndex}
                                            onClick={isExpand ? () => handleToggleExpand(valueIndex) : undefined}
                                            cursor={isExpand ? 'pointer' : 'default'}
                                        >
                                            <IterationComponent
                                                arr={filteredHeaders}
                                                render={(item, tableListIndex) => (
                                                    <Td
                                                        key={item?.value}
                                                        p={'16px 12px'}
                                                        fontSize={fontSize}
                                                        fontWeight={'500'}
                                                    >
                                                        <Flex gap={'12px'} alignItems={'center'}>
                                                            {tableListIndex === 0 && isExpand && (
                                                                <Box position={'relative'}>
                                                                    <Button
                                                                        variant={'unstyled'}
                                                                        px={0}
                                                                        minW={'10px'}
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            handleToggleExpand(valueIndex);
                                                                        }}
                                                                    >
                                                                        <ChevronUpIcon
                                                                            fontSize={24}
                                                                            color={'sagitarius.500'}
                                                                            transform={
                                                                                expandedRow === valueIndex
                                                                                    ? 'rotate(180deg)'
                                                                                    : 'rotate(90deg)'
                                                                            }
                                                                        />
                                                                    </Button>
                                                                </Box>
                                                            )}
                                                            {item.component({
                                                                ...value,
                                                                value: value[item.value],
                                                            })}
                                                        </Flex>
                                                    </Td>
                                                )}
                                            />
                                        </Tr>

                                        {expandedRow === valueIndex && isExpand && (
                                            <IterationComponent
                                                arr={value.list_products}
                                                render={(item) => {
                                                    const listBasePack = { ...omit(item, 'brand'), sku_id: item.id };
                                                    return (
                                                        <Tr key={valueIndex} bg={'semantic.200'}>
                                                            <IterationComponent
                                                                arr={filteredHeaders}
                                                                render={(item, idx) => {
                                                                    console.log('item: ', item);
                                                                    const lastIndex = size(filteredHeaders) - 1;
                                                                    return (
                                                                        <Td
                                                                            key={item?.value}
                                                                            p={'16px 12px'}
                                                                            fontSize={fontSize}
                                                                            fontWeight={'500'}
                                                                            colSpan={idx === lastIndex ? 2 : 0}
                                                                        >
                                                                            <Flex gap={'12px'} alignItems={'center'}>
                                                                                {item.component({
                                                                                    value: listBasePack[item.value],
                                                                                    is_basepack_child: true,
                                                                                })}
                                                                            </Flex>
                                                                        </Td>
                                                                    );
                                                                }}
                                                            />
                                                        </Tr>
                                                    );
                                                }}
                                            />
                                        )}
                                    </>
                                );
                            }}
                        />
                    </Tbody>
                </ConditionalComponent>

                <ConditionalComponent statement={isLoading}>
                    <Tbody>
                        <IterationComponent
                            arr={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10]}
                            render={(_, index) => (
                                <Tr key={index}>
                                    <IterationComponent
                                        arr={filteredHeaders}
                                        render={(item) => (
                                            <Td key={item?.value} p={'16px 12px'}>
                                                <Flex width="100%" justifyContent={item?.justifyContent}>
                                                    <SkeletonComponent
                                                        width="100%"
                                                        height={item?.skeleton?.height ?? '20px'}
                                                    />
                                                </Flex>
                                            </Td>
                                        )}
                                    />
                                </Tr>
                            )}
                        />
                    </Tbody>
                </ConditionalComponent>
            </Table>

            <NoData noData={isEmpty(data) && !isLoading} title={'Data Tidak Tersedia'} desc={noDataDescription} />

            <PaginationComp
                fontSize={fontSize}
                onChangeLimit={onChangeLimit}
                limit={limit}
                totalData={totalData}
                onPageChange={onPageChange}
                pageCount={pageCount}
                page={page}
            />
        </Box>
    );
}
